import { createSelector } from 'reselect';
import { List, Map } from 'immutable';

export const getUpgradeState = (state) =>
  state.upgrade;

export const getUpgradePaths =  (baseDevice, upgradeDevice) => createSelector(
  [getUpgradeState],
  (upgrade) => {
    const keysToCheck = List([
      `${baseDevice}Controller-${upgradeDevice}Controller`,
      `${baseDevice}Controller-${upgradeDevice}`,
      `${baseDevice}-${upgradeDevice}Controller`,
      `${baseDevice}-${upgradeDevice}`
    ]);
    let upgrades: any = List();
    keysToCheck.forEach(key => {
      const retrievedData = upgrade?.getIn(['upgrades', 'data', key], List());
      upgrades = upgrades.concat(retrievedData);
    });
    return upgrades.sort((a, b) => a.get('order') > b.get('order') ? 1 : -1);
  }
);


export const getPossibleUpgradePaths = (baseDeviceFactory) => createSelector(
  [getUpgradeState],
  (upgrade) => {
    if (!baseDeviceFactory || typeof baseDeviceFactory !== 'string') {
      return List(baseDeviceFactory);
    }

    const regex = new RegExp(`^${baseDeviceFactory.replace('Controller', '')}(?:Controller)?-(.*)`);
    const devicesFound = upgrade?.getIn(['upgrades', 'data'], Map())
      .keySeq() // get keys
      .filter(key => regex.test(key)) // filter keys where the regex = <baseDeviceFactory>-<device>
      .map(key => {
        const matchedKey = key.match(regex)[1]; // get the upgrade device name from the key
        return matchedKey.endsWith('Controller') ? matchedKey : matchedKey + 'Controller';
      })
      .toSet() // remove duplicates
      .toList(); // convert to list
    return devicesFound;
  }
);

export const getLoadingUpgrade = createSelector(
  [getUpgradeState],
  (upgrade) => {
    return upgrade.getIn(['upgrades', 'loading'], false);
  }
);
